module.exports = __webpack_public_path__ + "img/newsletter-background-desktop@2x.9e310eaf.jpg";